"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var MenuList_1 = require("./MenuList");
var menu_1 = require("../../utils/shopify/menu");
var MenuBody = function (_a) {
    var subMenu = _a.subMenu, menus = _a.menus;
    // If subMenu is set, render MenuBody with subMenu item
    if (subMenu) {
        return ((0, preact_1.h)("div", { class: "menu-body" },
            (0, preact_1.h)(MenuList_1.default, { menuItem: subMenu }),
            (0, preact_1.h)(MenuList_1.default, { menuItem: menus.shopAll, noTitle: true })));
    }
    // Find the current URL and store it with useMemo
    var prodMenuItem = (0, hooks_1.useMemo)(function () { return (0, menu_1.findUrlInMenu)(menus.category, location); }, []);
    return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)("div", { class: "menu-body" },
            prodMenuItem && ((0, preact_1.h)(MenuList_1.default, { menuItem: prodMenuItem, isProdMenu: true, className: "menu-list-product" })),
            (0, preact_1.h)(MenuList_1.default, { menuItem: menus.category, shopAllMenu: menus.shopAll, className: "menu-list-category" }),
            (0, preact_1.h)(MenuList_1.default, { menuItem: menus.collection, className: "menu-list-collection" }),
            (0, preact_1.h)(MenuList_1.default, { menuItem: menus.other, noTitle: true, className: "menu-list-other" }))));
};
exports.default = MenuBody;
